/* Harper : comportement de l'en-tete (FONDATIONS, 19/10/2026). Code neuf.
   - menu mobile plein ecran : ouverture, fermeture, accordeon, Echap, voile ;
   - etat « colle » de l'en-tete desktop (108 px -> 88 px) ;
   - variables --header-height et --header-group-height sur <body>, attendues par
     les composants d'Horizon (galerie produit, tiroirs). */
(function () {
  'use strict';
  var header = document.querySelector('[data-hh-header]');
  if (!header) return;
  var panel = document.getElementById('hh-panel');
  var voile = document.querySelector('.hh-voile');
  var opener = header.querySelector('[data-hh-open]');
  var section = header.closest('.shopify-section') || header;

  function setHeights() {
    /* hauteur VISIBLE de l'en-tete (88 px colle) ; la section, elle, garde 108 px dans le flux */
    var h = header.offsetHeight;
    var group = h;
    var annonce = document.querySelector('.hh-section-annonce');
    if (annonce) group += annonce.offsetHeight;
    document.body.style.setProperty('--header-height', h + 'px');
    document.body.style.setProperty('--header-group-height', group + 'px');
  }

  function open() {
    if (!panel) return;
    panel.removeAttribute('inert');
    panel.classList.add('is-ouvert');
    panel.setAttribute('aria-hidden', 'false');
    if (voile) voile.hidden = false;
    if (opener) opener.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('hh-menu-ouvert');
    document.body.style.overflow = 'hidden';
    document.dispatchEvent(new CustomEvent('harper:menu-open'));
    var first = panel.querySelector('.hh-panel__fermer');
    if (first) first.focus({ preventScroll: true });
  }

  function close() {
    if (!panel || !panel.classList.contains('is-ouvert')) return;
    panel.classList.remove('is-ouvert');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    if (voile) voile.hidden = true;
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
    document.documentElement.classList.remove('hh-menu-ouvert');
    document.body.style.overflow = '';
    panel.querySelectorAll('[data-hh-accordeon][aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      var cible = document.getElementById(b.getAttribute('aria-controls'));
      if (cible) cible.style.maxHeight = '0px';
    });
    document.dispatchEvent(new CustomEvent('harper:menu-close'));
  }

  if (opener) opener.addEventListener('click', open);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-hh-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  if (panel) {
    panel.querySelectorAll('[data-hh-accordeon]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cible = document.getElementById(btn.getAttribute('aria-controls'));
        if (!cible) return;
        var ouvert = btn.getAttribute('aria-expanded') === 'true';
        panel.querySelectorAll('[data-hh-accordeon]').forEach(function (autre) {
          if (autre === btn) return;
          autre.setAttribute('aria-expanded', 'false');
          var s = document.getElementById(autre.getAttribute('aria-controls'));
          if (s) s.style.maxHeight = '0px';
        });
        btn.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
        cible.style.maxHeight = ouvert ? '0px' : cible.scrollHeight + 'px';
      });
    });
  }

  /* Etat colle : seulement quand l'en-tete est collant (>= 769 px). */
  var desktop = window.matchMedia('(min-width: 769px)');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var colle = desktop.matches && section.getBoundingClientRect().top <= 0 && window.scrollY > 0;
      if (colle !== header.classList.contains('is-colle')) {
        header.classList.toggle('is-colle', colle);
        setHeights();
        setTimeout(setHeights, 260);
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { setHeights(); onScroll(); });
  if (desktop.addEventListener) desktop.addEventListener('change', function () { if (desktop.matches) close(); onScroll(); });

  setHeights();
  onScroll();
})();
